// --- Market-aware config (added for Shopify Markets support) ---
// Index + currency are chosen from the #current-market hidden input.
// NZ/Norfolk use their own market indices, so the availability metafield
// filter is only needed on the primary (Australia) index.
const PD_MARKETS = {
  "Australia":   { indexSuffix: "",                currency: "AUD", locale: "en-AU", pricingField: null,                 useAvailabilityFilter: true  },
  "New Zealand": { indexSuffix: "_new_zealand_en", currency: "NZD", locale: "en-NZ", pricingField: "market_pricing_nzd", useAvailabilityFilter: false },
  "Norfolk":     { indexSuffix: "_norfolk_en",     currency: "AUD", locale: "en-AU", pricingField: null,                 useAvailabilityFilter: false },
};
const pdMarketName = document.querySelector("#current-market")?.value?.trim() || "Australia";
const pdMarket = PD_MARKETS[pdMarketName] || PD_MARKETS["Australia"];
const pdProductsIndex = "shopify_products" + pdMarket.indexSuffix;

// Returns the object holding the correct prices for this market
// (market indices keep AUD in the top-level price fields and the market
// currency in market_pricing_<currency>).
const pdPricing = (hit) =>
  (pdMarket.pricingField && hit[pdMarket.pricingField]) ? hit[pdMarket.pricingField] : hit;
const pdFormatPrice = (v) =>
  (v ?? 0).toLocaleString(pdMarket.locale, { style: "currency", currency: pdMarket.currency });

class PD_Algolia_Search {
  constructor() {
    (this.i = [
      "https://cdnjs.cloudflare.com/ajax/libs/algoliasearch/4.24.0/algoliasearch-lite.umd.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/instantsearch.js/4.72.2/instantsearch.production.min.js",
    ]),
      (this.t = {}),
      (this.h = !1),
      (this.o = null),
      (this.instantsearchHelper = null),
      (this.l = null),
      (this.u = null),
      (this.g = null),
      (this.m = null),
      (this.p = null),
      (this.v = null),
      (this._ = null),
      (this.A = null),
      (this.L = null),
      (this.searchResultsEl = null);
  }
  init(i) {
    var {
      applicationId: t,
      searchKey: e,
      indexName: s,
      searchInputSelector: n,
      searchButtonSelector: h,
      widgetList: r,
      librariesToLoad: a,
      searchResultsSelector: o,
    } = i;
    return (
      (this.t = i),
      (this.l = t),
      (this.u = e),
      (this.g = s),
      (this.m = n),
      (this.p = h),
      (this.v = o),
      (this.searchResultsEl = document.querySelector(this.v)),
      this.R("Starting init."),
      this.S(),
      Array.isArray(a) &&
        (this.R("Overriding the default libraries for loading."), (this.i = a)),
      this.R("Loading required libraries..."),
      this.j()
        ? (this.R(
            "Stopping execution because we have added a library and have attached to its onload event."
          ),
          !1)
        : (this.R("No libraries to load."),
          this.R("Resetting event listeners on original elements..."),
          !1 === this.D()
            ? (this.R("Error resetting event listeners."), !1)
            : (this.R("Done."),
              this.R("Loading Algolia instance..."),
              !1 === this.N()
                ? (this.R("Error initializing Algolia."), !1)
                : (this.R("Done."),
                  this.R("Registering widgets with Algolia..."),
                  !1 === this.k(r)
                    ? (this.R("Error registering widgets."), !1)
                    : (this.o.start(),
                      this.R("Done."),
                      this.R("All done, search is ready."),
                      (this.h = !0)))))
    );
  }
  R(t, e = "info", i = !1) {
    if (window.location.search.includes("pd_search_log=true") || i) {
      let i = "[PD-AlgoliaSearch]";
      switch (e) {
        case "debug":
          i += " (DEBUG)";
          break;
        case "error":
          i += " (ERROR)";
          break;
        case "warn":
          i += " (WARN)";
          break;
        default:
          i += " (INFO)";
      }
      console.log(i, t);
    }
  }
  O() {
    return !1 === this.h && (this.R("Retrying init..."), this.init(this.t), !0);
  }
  // NOTE: Fixed - previously hardcoded `window.pd_search.O()` which meant only the products
  // instance got retried on DOMContentLoaded/load. Now uses `this` so each instance (collections,
  // content, pages, products) retries its own init independently.
  S() {
    const self = this;
    window.addEventListener("DOMContentLoaded", () => {
      self.O();
    }),
      window.addEventListener("load", () => {
        self.O();
      });
  }
  j() {
    return (
      0 <
      this.i
        .map((t) => {
          var i;
          return !(
            0 <
              Array.from(document.querySelectorAll("script")).filter(
                (i) => i.src === t
              ).length ||
            (((i = document.createElement("script")).onload = () => {
              this.R("Library loaded, attempting init again."), this.O();
            }),
            (i.defer = !0),
            (i.src = t),
            document.head.appendChild(i),
            0)
          );
        })
        .filter((i) => !0 === i).length
    );
  }
  // NOTE: Fixed - searchFunction previously hardcoded `window.pd_search` which caused all 4
  // instances to control the products container (#pd-results) visibility instead of their own.
  // Now uses `self` reference so each instance controls its own searchResultsEl and instantsearchHelper.
  N() {
    const self = this;
    return (
      "function" == typeof instantsearch &&
      "function" == typeof algoliasearch &&
      ((this.o = instantsearch({
        indexName: this.g,
        searchClient: algoliasearch(this.l, this.u),
        routing: !0,
        searchFunction: function (i) {
          self.instantsearchHelper = i;
          if (i.state.query === "") {
            self.searchResultsEl.classList.add("hidden");
            self.searchResultsEl.style.display = "none";
            //window.scrollTo(0, 0);
            document.body.classList.remove("pd-search-open");
          } else {
            // Only set the input value if the query isn't empty
            const searchInput = document.querySelector(
              "#pd-main-searchbox-input"
            );
            if (searchInput) {
              searchInput.value = i.state.query;
            }
            self.searchResultsEl.classList.remove("hidden");
            self.searchResultsEl.style.display = "";
            //window.scrollTo(0, 0);
            document.body.classList.add("pd-search-open");
            i.search();
          }
        },
      })),
      !0)
    );
  }
  D() {
    this._ = document.querySelector(this.m);
    this.A = document.querySelector(this.p);

    if (!this._) {
      console.error("Search input element not found");
      return false;
    }

    this._.addEventListener("input", (i) => {
      this.L = i.target.value;
    });

    if (this.A) {
      this.A.addEventListener("click", () => {
        this.F(this.L || "");
      });
    } else {
      console.warn("Search button element not found");
    }

    return true;
  }
  F(i) {
    return !(
      !this.instantsearchHelper ||
      void 0 === this.instantsearchHelper.setQuery ||
      (this.instantsearchHelper.setQuery(i), 0)
    );
  }
  k(i) {
    return (
      "function" == typeof this.o.addWidgets && (this.o.addWidgets(i()), !0)
    );
  }
  searchInputExists() {
    return !!document.querySelector(this.m);
  }
  createSearchInput() {
    const existingInput = document.querySelector(this.m);
    if (!existingInput) {
      const searchContainer = document.querySelector("#pd-main-searchbox");
      if (searchContainer) {
        const newInput = document.createElement("input");
        newInput.type = "text";
        newInput.id = this.m.replace("#", "");
        newInput.placeholder = "Search";
        searchContainer.prepend(newInput);
      }
    }
  }
}

// Initialize content.
window.pd_search_collections = new PD_Algolia_Search();
window.pd_search_collections.init({
	applicationId: 'TRW2B69G8U',
	searchKey: '73173f3312153041139a04c6a3ef4ee6',
	indexName: 'shopify_collections',
	searchInputSelector: '#pd-main-searchbox-input',
	skipSearchInputOverride: true,
	searchButtonSelector: '#pd-main-searchbox-button',
	searchResultsSelector: '#pd-results-collections',
	widgetList: () => {
		let mainSearchbox = instantsearch.connectors.connectSearchBox(
			function (
				renderOptions,
				isFirstRender
			) {
				let widgetParams = renderOptions.widgetParams;

				if (isFirstRender) {
					document.querySelector(widgetParams.container).addEventListener(
						'input',
						function (event) {
							renderOptions.refine(event.target.value);
						}
					);
				}
			}
		);

		return [
			instantsearch.widgets.configure({
				hitsPerPage: 12,
			}),
			mainSearchbox(
				{
					container: '#pd-main-searchbox-input',
					placeholder: 'Search',
				}
			),
      instantsearch.widgets.pagination({
        container: "#pd-collections-pagination",
        showFirst: false,
        showLast: false,
        cssClasses: {
            root: "",
            list: "ais-Pagination-list pagination-custom",
            item: "ais-Pagination-item pagination-custom__num",
            selectedItem: "ais-Pagination-item--selected active",
            link: "ais-Pagination-link",
        },
      }),
			instantsearch.widgets.hits(
				{
					container: '#pd-results-collections',
					templates: {
						item(hit) {
              const placeholder = 'https://hammerroo.com.au/cdn/shop/files/ef3fb3c9837710d1b3c0906609faa3225d681054.png';
              const fallbackFromJson = window.pd_collection_fallbacks?.[hit.handle];
              const imgSrc = hit.image || fallbackFromJson || placeholder;

              return `
                <div class="pd-algolia-content">
                  <a href="/collections/${hit.handle}">
                    <img src="${imgSrc}" alt="${hit.title}">
                  </a>
                  <a class="pd-algolia-content-link" href="/collections/${hit.handle}">${hit.title}</a>
                </div>`;
            },
						empty: '<div class="pd-empty-results">No results found matching <strong></strong>.</div>',
					}
				}
			)
		]
	}
});

// Initialize content.
window.pd_search_content = new PD_Algolia_Search();
window.pd_search_content.init({
	applicationId: 'TRW2B69G8U',
	searchKey: '73173f3312153041139a04c6a3ef4ee6',
	indexName: 'shopify_articles',
	searchInputSelector: '#pd-main-searchbox-input',
	skipSearchInputOverride: true,
	searchButtonSelector: '#pd-main-searchbox-button',
	searchResultsSelector: '#pd-results-blog',
	widgetList: () => {
		let mainSearchbox = instantsearch.connectors.connectSearchBox(
			function (
				renderOptions,
				isFirstRender
			) {
				let widgetParams = renderOptions.widgetParams;

				if (isFirstRender) {
					document.querySelector(widgetParams.container).addEventListener(
						'input',
						function (event) {
							renderOptions.refine(event.target.value);
						}
					);
				}
			}
		);

		return [
			instantsearch.widgets.configure({
				hitsPerPage: 12,
			}),
			mainSearchbox(
				{
					container: '#pd-main-searchbox-input',
					placeholder: 'Search',
				}
			),
      instantsearch.widgets.pagination({
        container: "#pd-blog-pagination",
        showFirst: false,
        showLast: false,
        cssClasses: {
            root: "",
            list: "ais-Pagination-list pagination-custom",
            item: "ais-Pagination-item pagination-custom__num",
            selectedItem: "ais-Pagination-item--selected active",
            link: "ais-Pagination-link",
        },
      }),
			instantsearch.widgets.hits(
				{
					container: '#pd-results-blog',
					templates: {
						item: function item(hit) {
							return `<div class="pd-algolia-content"><a href="/blogs/${hit.blog.handle}/${hit.handle}" target="_blank"><img src="${hit.image ? hit.image : 'https://hammerroo.com.au/cdn/shop/files/ef3fb3c9837710d1b3c0906609faa3225d681054.png'}" class="${hit.image ? '' : 'empty-img'}"></a><a class="pd-algolia-content-link" href="/blogs/${hit.blog.handle}/${hit.handle}" target="_blank">${hit.title}</a></div>`
						},
						empty: '<div class="pd-empty-results">No results found matching <strong></strong>.</div>',
					}
				}
			)
		]
	}
});


// Initialize content.
window.pd_search_pages = new PD_Algolia_Search();
window.pd_search_pages.init({
	applicationId: 'TRW2B69G8U',
	searchKey: '73173f3312153041139a04c6a3ef4ee6',
	indexName: 'shopify_pages',
	searchInputSelector: '#pd-main-searchbox-input',
	skipSearchInputOverride: true,
	searchButtonSelector: '#pd-main-searchbox-button',
	searchResultsSelector: '#pd-results-pages',
	widgetList: () => {
		let mainSearchbox = instantsearch.connectors.connectSearchBox(
			function (
				renderOptions,
				isFirstRender
			) {
				let widgetParams = renderOptions.widgetParams;

				if (isFirstRender) {
					document.querySelector(widgetParams.container).addEventListener(
						'input',
						function (event) {
							renderOptions.refine(event.target.value);
						}
					);
				}
			}
		);

		return [
			instantsearch.widgets.configure({
				hitsPerPage: 12,
			}),
			mainSearchbox(
				{
					container: '#pd-main-searchbox-input',
					placeholder: 'Search',
				}
			),
      instantsearch.widgets.pagination({
        container: "#pd-page-pagination",
        showFirst: false,
        showLast: false,
        cssClasses: {
            root: "",
            list: "ais-Pagination-list pagination-custom",
            item: "ais-Pagination-item pagination-custom__num",
            selectedItem: "ais-Pagination-item--selected active",
            link: "ais-Pagination-link",
        },
      }),
			// NOTE: Fixed - previously used blog template (hit.blog.handle) which doesn't exist on page hits,
			// causing a JS error and preventing render. Changed to use /pages/${hit.handle} for correct page URLs.
			instantsearch.widgets.hits(
				{
					container: '#pd-results-pages',
					templates: {
						item: function item(hit) {
              let featured_image_link = hit.meta?.custom?.featured_image_link;
							return `<div class="pd-algolia-content"><a href="/pages/${hit.handle}" target="_blank"><img src="${featured_image_link ? featured_image_link : 'https://hammerroo.com.au/cdn/shop/files/ef3fb3c9837710d1b3c0906609faa3225d681054.png'}" class="${featured_image_link ? '' : 'empty-img'}"></a><a class="pd-algolia-content-link" href="/pages/${hit.handle}" target="_blank">${hit.title}</a></div>`
						},
						empty: '<div class="pd-empty-results">No results found matching <strong></strong>.</div>',
					}
				}
			)
		]
	}
});

// Initialize - docs for all parameters can be found above.
window.pd_search = new PD_Algolia_Search();
window.pd_search.init({
    applicationId: "TRW2B69G8U",
    searchKey: "73173f3312153041139a04c6a3ef4ee6",
    // NOTE: Markets - per-market products index (e.g. shopify_products_new_zealand_en on the NZ domain)
    indexName: pdProductsIndex,
    searchInputSelector: "#pd-main-searchbox-input",
    skipSearchInputOverride: true,
    searchButtonSelector: "#pd-main-searchbox-button",
    searchResultsSelector: "#pd-results",
    widgetList: () => {
        let mainSearchbox = instantsearch.connectors.connectSearchBox(function (
        renderOptions,
        isFirstRender
        ) {
        let widgetParams = renderOptions.widgetParams;

        if (isFirstRender) {
            document
            .querySelector(widgetParams.container)
            .addEventListener("input", function (event) {
                renderOptions.refine(event.target.value);
            });
        }
    });

    return [
    instantsearch.widgets.configure({
      hitsPerPage: 16,
      // NOTE: Markets - the availability metafield filter is only needed on the primary
      // (Australia) index. The NZ/Norfolk indices already contain only the products
      // published to those markets, and the facet may not be declared on them.
      filters: pdMarket.useAvailabilityFilter
      ? `meta.custom.algolia_available_markets:"${pdMarketName} "`
      : "",
      optionalFilters: ["tags:-spare parts"], // Push "spare parts" to the bottom
    }),
    mainSearchbox({
      container: "#pd-main-searchbox-input",
      placeholder: "Search..",
    }),
    instantsearch.widgets.pagination({
      container: "#pd-pagination",
      showFirst: false,
      showLast: false,
      cssClasses: {
          root: "",
          list: "ais-Pagination-list pagination-custom",
          item: "ais-Pagination-item pagination-custom__num",
          selectedItem: "ais-Pagination-item--selected active",
          link: "ais-Pagination-link",
      },
    }),
    instantsearch.widgets.hits({
        container: "#pd-results",
        templates: {
          item: function item(hit) {
            // NOTE: Markets - p holds the correct prices for the current market
            // (market_pricing_nzd on NZ, top-level fields elsewhere).
            const p = pdPricing(hit);
            let discount_price = (p.compare_at_price ?? 0) - p.price;
            let freeGiftBadge = hit.meta?.custom?.free_gift_gifts;
            let stringDiscountPriceFinal = "";
            let showNewBadge = false;
            let poaProduct = false;
            let inventoryBadge = "";
            let dataInventoryLevel = "";
            let productInventoryStatus = "product-inventory__status";
            const inventory = Number(hit.inventory_quantity ?? 0);
            const policy = hit.inventory_policy || "deny";
            const veryLowThreshold = 3;
            const lowThreshold = 10;

            if (inventory === 0 && hit.inventory_policy === "deny") {
              productInventoryStatus = "";
            } else if (inventory <= 0 && policy === "continue") {
              inventoryBadge = "Special Order";
              dataInventoryLevel = 'data-inventory-level="backordered"';
            } else if (inventory > 0 && inventory <= veryLowThreshold) {
              if (inventory > 1) {
                dataInventoryLevel = 'data-inventory-level="low"';
                inventoryBadge = `Low Stock(${inventory} units)`;
              } else {
                dataInventoryLevel = 'data-inventory-level="very_low"';
                inventoryBadge = "Last One Left(1 unit)";
              }
            } else {
              inventoryBadge = "In Stock";
              dataInventoryLevel = 'data-inventory-level="normal"';
            }

            if (discount_price > 0) {
              let discountPricePercentage = Math.floor(
                ((p.compare_at_price - p.price) / p.compare_at_price) * 100
              );
              stringDiscountPriceFinal = `${discountPricePercentage}% Off`;
            }

            if (!showNewBadge && hit.created_at) {
              const now = new Date();
              const created = new Date(hit.created_at);
              const diffDays = (now - created) / (1000 * 60 * 60 * 24);
              const newLimitDays = 29;
              if (diffDays < newLimitDays) {
                showNewBadge = true;
              }
            }
            if (hit.collections && Array.isArray(hit.collections)) {
              if (hit.collections.some(col => col.handle === "new-products")) {
                showNewBadge = true;
              }
            }
            if (!showNewBadge && hit.tags && Array.isArray(hit.tags)) {
              const tagsLower = hit.tags.map(t => t.toLowerCase());
              if (tagsLower.includes("new")) {
                showNewBadge = true;
              }
            }

            if (hit.tags && Array.isArray(hit.tags)) {
              const tagsLower = hit.tags.map(t => t.toLowerCase());
              if (tagsLower.includes("poa-product")) {
                poaProduct = true;
              }
            }

            return `
            <div class="card-wrapper product-card-wrapper">
                <div class="ais-hit ais-product card card--standard card--media" data-handle="${hit.handle}"
                    data-algolia-objectid="${hit.objectID}"  data-variant-id="${hit.objectID}"  data-product-id="${hit.id}">

                    <div class="card__inner color-background-2 gradient ratio relative">
                        <div class="card__media">
                        ${freeGiftBadge? `<img src="https://cdn.shopify.com/s/files/1/0882/9419/5516/files/free_gift.svg?v=1752749006" alt="Free Gift"
                            class="free-gift-icon" width="85" height="80">` : ``}
                            <a data-algolia-objectid="${hit.objectID}"
                            href="/products/${hit.handle}" title="${hit.title}" class="media media--transparent media--hover-effect" data-tester="${hit.product_image}">
                                <img class="ais-hit--picture" src="${ hit.product_image }" alt="${hit.title} - ${hit.variant_title}"/>
                            </a>
                        </div>
                        <a href="/products/${hit.handle }" class="thumbnail-image-link">
                            <div class="ais_badge card__badge absolute top-0 end" style="z-index: 1">
                                <div class="product-label-container">
                                    ${hit.inventory_quantity < 1 && hit.inventory_policy === "deny"?
                                        `<div class="product-label-wrapper flex justify-end">
                                            <span class="product-label product-label--sold-out">
                                              Out Of Stock
                                            </span>
                                        </div>`
                                        : ``
                                    }
                                    ${p.price < p.compare_at_price ?
                                        `<div class="product-label-wrapper flex justify-end">
                                            <span class="product-label product-label--sale">
                                                ${stringDiscountPriceFinal}
                                            </span>
                                        </div>`
                                        : ``
                                    }
                                    ${showNewBadge ?
                                        `<div class="product-label-wrapper flex justify-end">
                                          <span class="product-label product-label--new">
                                            New Arrival
                                          </span>
                                        </div>`
                                        : ``
                                    }
                                </div>
                            </div>
                        </a>
                        <form id="algolia-add-to-cart-${hit.objectID}"
                            style="display: none;" action="/cart/add" method="post" enctype="multipart/form-data">
                            <input type="hidden" name="id" value="${hit.objectID}">
                        </form>
                        <p class="ais-hit--cart btn-state-ready stain-button-canvas group/quick-action-button bg-button flex items-center justify-center typography-accent-bold text-a3
                                transition-opacity duration-[--enter-animation-duration] pointer-events-auto  w-8 aspect-square min-w-[40px]  min-h-[40px] md:min-h-[48px]
                                md:px-5 md:py-3 md:w-full md:aspect-auto">
                            <button class="ais-hit--cart-button btn-state-ready text-button-contrast group-hover/quick-action-button:text-button-contrast/50 whitespace-nowrap"
                                  data-form-id="algolia-add-to-cart-${hit.objectID}">Add to cart</button>
                        </p>
                    </div>
                    <div class="ais-hit--details product__grid__info card__content">
                        <a data-algolia-objectid="${hit.objectID}" href="/products/${hit.handle }" title="${hit.title}">
                            <div class="ais-hit--details card__information">
                                <div class="product__grid__title__wrapper card__heading text-current">
                                    <p class="ais-hit--subtitle product__grid__title" title="${hit.product_type} ${hit.vendor ? " by " + hit.vendor : ""}">

                                        ${hit.vendor? "" + instantsearch.highlight({ attribute: "vendor", hit: hit, })
                                            : ""
                                        }
                                    </p>
                                    <p class="ais-hit--title product__grid__title card__heading text-current">
                                        ${instantsearch.highlight({ attribute: "title", hit: hit })}
                                    </p>
                                </div>

                                <div class="product__grid__price  product__grid__price--nowrap price">
                                    <div class="card-information">
                                        ${poaProduct ?
                                            `<div class="price__poa-notice price__poa-notice price price--top">
                                                Contact for pricing
                                              </div>`
                                            : `<div class="price__container">
                                              ${p.price < p.compare_at_price ?
                                              `<div class="price  price--on-sale">
                                                  <span class="price__container">
                                                      <span class="compare-at ais-hit--price price__sale">
                                                          ${p.variants_min_price !== p.variants_max_price ? `<span class="price-from-label">From </span>` : ``}
                                                          ${pdFormatPrice(p.price)}
                                                      </span>
                                                  </span>
                                                  <div class="price__regular show">
                                                      <span class="price-item price-item--regular">
                                                          ${pdFormatPrice(p.compare_at_price)}
                                                      </span>
                                                  </div>
                                              </div>`
                                                  :
                                              `<span class="price ais-hit--price price__regular show">
                                                  <span class="price-item price-item--regular">
                                                      ${p.variants_min_price !== p.variants_max_price ? `<span class="price-from-label">From </span>` : ``}
                                                      ${pdFormatPrice(p.price)}
                                                  </span>
                                              </span>`
                                              }
                                          </div>`
                                        }
                                        <p class="ais-hit--info" style="display: none;">
                                            <span class="algolia-sku">
                                            ${instantsearch.highlight({ attribute: "sku", hit: hit })}
                                            </span>
                                            <span class="algolia-barcode">
                                            ${instantsearch.highlight({
                                                attribute: "barcode",
                                                hit: hit,
                                            })}
                                            </span>
                                            <span class="algolia-weight">
                                            ${instantsearch.highlight({
                                                attribute: "weight",
                                                hit: hit,
                                            })}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="pt-5 text-xs ${productInventoryStatus}" ${dataInventoryLevel}>
                                    ${inventoryBadge}
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>`;
        },
        empty:
            '<div class="pd-empty-results">No results found matching <strong></strong>.</div>',
        },
        cssClasses: {
            item: "ais-Hits-item",
            list: "ais-Hits-list",
        },
    }),

  /*
    // ---------- REPLACE product instantsearch.widgets.hits({...}) WITH THIS CUSTOM WIDGET ----------
(function () {
  return {
    init() {
      // no special initialization required
    },

    async render(renderOptions) {
      const { results, widgetParams, state } = renderOptions || {};
      const productHits = (results && results.hits) || [];
      const query = (state && state.query) || "";

      // how many blog posts we might need for this page
      //const blogsNeeded = Math.max(0, Math.ceil(productHits.length / 7));

      // Determine which page we are on from the product hits
      const productsPerPage = 14;
      const blogsPerPage = 2;

      // Calculate current product page number (1-indexed)
      const productPage = state?.page || 0; // depends on your search state, adjust if needed
      const startProductIndex = productPage * productsPerPage;

      // Number of blog hits we need per page (2 per product page)
      const blogsNeeded = blogsPerPage;

      // Offset for blogs based on current product page
      const blogOffset = productPage * blogsPerPage;


      // fetch blog hits from existing blog search client if available
      let blogHits = [];
      try {
        if (
          window.pd_search_content &&
          window.pd_search_content.o &&
          window.pd_search_content.o.searchClient
        ) {
          const blogSearchClient = window.pd_search_content.o.searchClient;
          const blogRes = await blogSearchClient.search([
            {
              indexName: "shopify_articles",
              query: query,
              params: { hitsPerPage: blogsNeeded, page: productPage },
            },
          ]);
          blogHits =
            (blogRes &&
              blogRes.results &&
              blogRes.results[0] &&
              blogRes.results[0].hits) ||
            [];
        } else if (typeof algoliasearch === "function") {
          const appId = window.pd_search_content?.l || window.pd_search?.l;
          const apiKey = window.pd_search_content?.u || window.pd_search?.u;
          if (appId && apiKey) {
            const fallbackClient = algoliasearch(appId, apiKey);
            const blogRes = await fallbackClient.search([
              {
                indexName: "shopify_articles",
                query: query,
                params: { hitsPerPage: blogsNeeded, page: productPage },
              },
            ]);
            blogHits =
              (blogRes &&
                blogRes.results &&
                blogRes.results[0] &&
                blogRes.results[0].hits) ||
              [];
          }
        }
      } catch (err) {
        console.warn(
          "[PD-AlgoliaSearch] Error fetching blog hits for merge:",
          err
        );
        blogHits = [];
      }

      // Merge: 1 blog first, then 7 products, then next blog, etc.
      const merged = [];
      let blogIndex = 0;
      let productIndex = 0;

      while (productIndex < productHits.length || blogIndex < blogHits.length) {
        if (blogIndex < blogHits.length) {
          merged.push({ type: "blog", data: blogHits[blogIndex] });
          blogIndex++;
        }

        for (let i = 0; i < 7 && productIndex < productHits.length; i++, productIndex++) {
          merged.push({ type: "product", data: productHits[productIndex] });
        }
      }

      // Ensure #pd-results has the wrapper structure
      let container = document.querySelector("#pd-results");
      if (!container) {
        console.warn("[PD-AlgoliaSearch] #pd-results container not found.");
        return;
      }

      if (!container.querySelector(".ais-Hits")) {
        container.querySelector(".js-grid").innerHTML = `
          <div class="ais-Hits">
            <ul class="ais-Hits-list"></ul>
          </div>
        `;
      }

      const targetList = container.querySelector(".ais-Hits-list");

      // Render using the existing product template and blog template
      targetList.innerHTML = merged
        .map((item) => {
          if (item.type === "product") {
            const hit = item.data;
            // --- BEGIN product template (unchanged) ---
            let discount_price = hit.compare_at_price - hit.price;
            let freeGiftBadge = hit.meta?.custom?.free_gift_gifts;
            let stringDiscountPriceFinal = "";
            let showNewBadge = false;
            let inventoryBadge = "";
            let dataInventoryLevel = "";
            let productInventoryStatus = "product-inventory__status";
            const inventory = Number(hit.inventory_quantity ?? 0);
            const policy = hit.inventory_policy || "deny";
            const veryLowThreshold = 3;

            if (inventory === 0 && hit.inventory_policy === "deny") {
              productInventoryStatus = "";
            } else if (inventory <= 0 && policy === "continue") {
              inventoryBadge = "Special Order";
              dataInventoryLevel = 'data-inventory-level="backordered"';
            } else if (inventory > 0 && inventory <= veryLowThreshold) {
              if (inventory > 1) {
                dataInventoryLevel = 'data-inventory-level="low"';
                inventoryBadge = `Low Stock(${inventory} units)`;
              } else {
                dataInventoryLevel = 'data-inventory-level="very_low"';
                inventoryBadge = "Last One Left(1 unit)";
              }
            } else {
              inventoryBadge = "In Stock";
              dataInventoryLevel = 'data-inventory-level="normal"';
            }

            if (discount_price > 0) {
              let discountPricePercentage = Math.floor(
                ((hit.compare_at_price - hit.price) / hit.compare_at_price) * 100
              );
              stringDiscountPriceFinal = `${discountPricePercentage}% Off`;
            }

            if (!showNewBadge && hit.created_at) {
              const now = new Date();
              const created = new Date(hit.created_at);
              const diffDays = (now - created) / (1000 * 60 * 60 * 24);
              const newLimitDays = 29;
              if (diffDays < newLimitDays) showNewBadge = true;
            }
            if (hit.collections && Array.isArray(hit.collections)) {
              if (hit.collections.some((col) => col.handle === "new-products")) {
                showNewBadge = true;
              }
            }
            if (!showNewBadge && hit.tags && Array.isArray(hit.tags)) {
              const tagsLower = hit.tags.map((t) => t.toLowerCase());
              if (tagsLower.includes("new")) showNewBadge = true;
            }

            return `<li class="ais-Hits-item">
            <div class="card-wrapper product-card-wrapper">
              <div class="ais-hit ais-product card card--standard card--media" data-handle="${hit.handle}"
                  data-algolia-objectid="${hit.objectID}"  data-variant-id="${hit.objectID}"  data-product-id="${hit.id}">
                <div class="card__inner color-background-2 gradient ratio relative">
                  <div class="card__media">
                    ${freeGiftBadge? `<img src="https://cdn.shopify.com/s/files/1/0882/9419/5516/files/free_gift.svg?v=1752749006" alt="Free Gift" class="free-gift-icon" width="85" height="80">` : ``}
                    <a data-algolia-objectid="${hit.objectID}"
                      href="/products/${hit.handle}" title="${hit.title}" class="media media--transparent media--hover-effect" data-tester="${hit.product_image}">
                      <img class="ais-hit--picture" src="${ hit.product_image }" alt="${hit.title} - ${hit.variant_title}"/>
                    </a>
                  </div>
                  <div class="ais_hit--details product__grid__info card__content">
                    <a data-algolia-objectid="${hit.objectID}" href="/products/${hit.handle }" title="${hit.title}">
                      <div class="ais-hit--details card__information">
                        <div class="product__grid__title__wrapper card__heading text-current">
                          <p class="ais-hit--subtitle product__grid__title" title="${hit.product_type} ${hit.vendor ? " by " + hit.vendor : ""}">
                            ${hit.vendor? "" + instantsearch.highlight({ attribute: "vendor", hit: hit }) : ""}
                          </p>
                          <p class="ais-hit--title product__grid__title card__heading text-current">
                            ${instantsearch.highlight({ attribute: "title", hit: hit })}
                          </p>
                        </div>
                      </div>
                    </a>

                  </div>
                </div>
              </div>
            </div></li>`;
            // --- END product template copy ---
          } else {
            const hit = item.data;
            return `<li class="ais-Hits-item"><div class="pd-algolia-content"><a href="/blogs/${hit.blog.handle}/${hit.handle}" target="_blank"><img src="${hit.image ? hit.image : 'https://hammerroo.com.au/cdn/shop/files/ef3fb3c9837710d1b3c0906609faa3225d681054.png'}" class="${hit.image ? '' : 'empty-img'}"></a><a class="pd-algolia-content-link" href="/blogs/${hit.blog.handle}/${hit.handle}" target="_blank">${hit.title}</a></div></li>`;
          }
        })
        .join("");
    },
  };
})(), */


    // Price filter
    // NOTE: Markets - slider filters the market-specific price attribute on NZ.
    instantsearch.widgets.rangeSlider({
        container: "#pd-price",
        attribute: pdMarket.pricingField ? `${pdMarket.pricingField}.price` : "price",
        tooltips: {
            format: function (rawValue) {
            return "$" + Math.round(rawValue).toLocaleString();
            },
        },
    }),

    // Product Type filter
    instantsearch.widgets.refinementList({
    container: "#pd-product_type",
    attribute: "product_type",
    limit: 7,
    showMore: true,
    searchable: false,
    searchablePlaceholder: "Search product types",
    cssClasses: {
        searchableInput: "form-control",
        searchableSubmit: "d-none",
        searchableReset: "d-none",
    },
    templates: {
        item(item, { html, components }) {
        return html`
            <label class="ais-RefinementList-label">
            <input
                class="ais-RefinementList-checkbox"
                type="checkbox"
                value="${item.value}"
                ${item.isRefined ? "checked" : ""}
            />
            <div class="icon-checkmark-wrapper">
                <svg aria-hidden="true" class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" ></path>
                </svg>
            </div>
            <span class="ais-RefinementList-labelText">${item.label}</span>
            <span class="ais-RefinementList-count">${item.count}</span>
            </label>
        `;
        },
    },
    }),

    // Vendor filter
    instantsearch.widgets.refinementList({
    container: "#pd-brands",
    attribute: "vendor",
    limit: 7,
    showMore: true,
    searchable: false,
    searchablePlaceholder: "Search vendors",
    cssClasses: {
        searchableInput: "form-control",
        searchableSubmit: "d-none",
        searchableReset: "d-none",
    },
    templates: {
        item(item, { html, components }) {
        return html`
            <label class="ais-RefinementList-label">
            <input class="ais-RefinementList-checkbox" type="checkbox" value="${item.value}" ${item.isRefined ? "checked" : ""} />
            <div class="icon-checkmark-wrapper">
                <svg aria-hidden="true" class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg" >
                  <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" ></path>
                </svg>
            </div>
            <span class="ais-RefinementList-labelText">${item.label}</span>
            <span class="ais-RefinementList-count">${item.count}</span>
            </label>
        `;
        },
    },
    }),

    /* Category filter
    instantsearch.widgets.hierarchicalMenu({
      container: "#pd-categories",
      attributes: [
        "category.lvl0",
        "category.lvl1",
        "category.lvl2",
      ],
      sortBy: ["isRefined", "name:asc"],
      limit: 7,
      showMore: true,
      searchable: false,
      templates: {
        item(item, { html, components }) {
          return html`
            <label class="ais-RefinementList-label">
            <input class="ais-RefinementList-checkbox" type="checkbox" value="${item.value}" ${item.isRefined ? "checked" : ""} />
            <div class="icon-checkmark-wrapper">
                <svg aria-hidden="true" class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg" >
                  <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" ></path>
                </svg>
            </div>
            <span class="ais-RefinementList-labelText">${item.label}</span>
            <span class="ais-RefinementList-count">${item.count}</span>
            </label>
          `;
        },
      },
      cssClasses: {
        searchableInput: "form-control",
        searchableSubmit: "d-none",
        searchableReset: "d-none",
      },
    }),
    */

    // Colour filter
    instantsearch.widgets.refinementList({
      container: "#pd-color",
      attribute: "options.color",
      limit: 7,
      showMore: true,
      searchable: false,
      searchablePlaceholder: "Search colours",
      cssClasses: {
        searchableInput: "form-control",
        searchableSubmit: "d-none",
        searchableReset: "d-none",
      },
      templates: {
        item(item, { html }) {
          return html`
            <label class="ais-RefinementList-label">
              <input
                class="ais-RefinementList-checkbox"
                type="checkbox"
                value="${item.value}"
                ${item.isRefined ? "checked" : ""}
              />
              <div class="icon-checkmark-wrapper">
                <svg
                  aria-hidden="true"
                  class="icon icon-checkmark"
                  width="1.1rem"
                  height="0.7rem"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1"
                    stroke="currentColor"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <span class="ais-RefinementList-labelText">${item.label}</span>
              <span class="ais-RefinementList-count">${item.count}</span>
            </label>
          `;
        },
      },
    }),


    // NOTE: Markets - sort replicas are per-market (e.g. shopify_products_new_zealand_en_price_asc).
    instantsearch.widgets.sortBy({
      container: "#pd-sort-by",
      items: [
        { value: pdProductsIndex, label: "Featured" },
        { value: `${pdProductsIndex}_recently_ordered_count_desc`, label: "Best selling" },
        { value: `${pdProductsIndex}_price_asc`, label: "Price, low to high" },
        { value: `${pdProductsIndex}_price_desc`, label: "Price, high to low" },
      ],
      cssClasses: {
        root: "",
        select: "form-control",
      },
      label: "sort by",
    }),

    instantsearch.widgets.stats({
    container: "#pd-stats",
    templates: {
        text:
        "No results" +
        "1 product" +
        " products",
    },
    }),

    instantsearch.widgets.clearRefinements({
        container: "#closeAlgolia",
        includedAttributes: [
            "query",
            "categories.lvl0",
            "categories.lvl1",
            "categories.lvl2",
            "categories.lvl3",
            "brand",
        ],
        templates: {
            resetLabel: "",
        },
        cssClasses: {
            button: ["npopup-btn-close hidden"],
        },
        }),
    ];
  },
});

// Cache common elements for reuse
const body = document.body;
const closeAlgoliaBtn = document.querySelector("#closeAlgolia");
const searchboxInput = document.querySelector("input#pd-main-searchbox-input");
const showFiltersBtn = document.querySelector("div#pd-show-filters");
const filters = document.querySelector("aside#pd-filters");
const results = document.querySelector("div#pd-results");

// Helper function to toggle visibility using CSS class
function toggleVisibility(label) {
  const wrapper = label.parentNode;
  const filter = wrapper.querySelector(".pd_filter_box");

  if (wrapper && filter) {
    wrapper.classList.toggle("open");
    filter.style.display = filter.style.display === "none" ? "block" : "none";
  }
}

// Open search functionality
const openPdSearchBtn = document.querySelector(".open_pd_search");
if (openPdSearchBtn) {
  openPdSearchBtn.addEventListener("click", function () {
    body.classList.add("pd-search-open");
  });
}

// Close search functionality
const closePdSearchBtn = document.querySelector(".close_pd_search");
if (closePdSearchBtn && closeAlgoliaBtn && searchboxInput) {
  closePdSearchBtn.addEventListener("click", function () {
    closeAlgoliaBtn.click();
    searchboxInput.value = "";
    body.classList.remove("pd-search-open");
  });
}

// Toggle individual filters
const pdFilterTitles = document.querySelectorAll(".pd_filter_title");
if (pdFilterTitles.length > 0) {
  pdFilterTitles.forEach(function (filterTitle) {
    filterTitle.addEventListener("click", function () {
      toggleVisibility(filterTitle);
    });
  });
}

// Show/hide filters panel - filters are hidden by default
function initPdSearchFilters() {
  // if (filters) {
    // filters.classList.add("hidden"); // Hide filters by default
  // }

  if (showFiltersBtn && filters && results) {
    const filterButtonText = showFiltersBtn.querySelector("div");
    if (filterButtonText) {
      filterButtonText.textContent = "Hide"; // Set initial text
    }

    // Toggle filters on button click
    showFiltersBtn.addEventListener("click", function () {
      const isFiltersVisible = filterButtonText.textContent === "Hide";

      filterButtonText.textContent = isFiltersVisible ? "Filter" : "Hide";
      filters.classList.toggle("hidden", isFiltersVisible);
      results.classList.toggle("full", isFiltersVisible);
    });

    // Check if screen width is less than 768px
    if (window.innerWidth < 768) {
        // Find the element and trigger click
        const element = document.getElementById('pd-show-filters');
        if (element) {
            element.click();
        }
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPdSearchFilters, { once: true });
} else {
  initPdSearchFilters();
}

document.querySelectorAll('.pd-alg-tab-trigger').forEach(button => {
  button.addEventListener('click', () => {
    // Remove active class from all buttons
    document.querySelectorAll('.pd-alg-tab-trigger').forEach(btn => btn.classList.remove('active'));
    // Add active class to clicked button
    button.classList.add('active');

    // Hide all tab contents
    document.querySelectorAll('.pd-alg-tab-content').forEach(tab => tab.classList.remove('active'));

    // Show target tab
    const target = document.querySelector(button.getAttribute('data-target'));
    if (target) target.classList.add('active');
  });
});